module.exports = __webpack_public_path__ + "media/images/webpage/hotels/7167/bath-ceb7316b7f0c6e8729ba94783b0e5f72.webp";